import React from 'react';
import * as MUI from '@mui/material';

const AccountSummary = ({ account }) => {
  if (!account) return null;

  return (
     <MUI.Paper sx={{ p: 2, mb: 2 }}>
      <MUI.Typography variant="body2" color="text.secondary" gutterBottom>
        Доступно сегодня
      </MUI.Typography>
      
      <MUI.Box display="flex" alignItems="baseline" sx={{ mb: 2 }}>
        <MUI.Typography variant="h3" color={account.balance >= 0 ? "success.main" : "error.main"} sx={{ fontWeight: 'bold', lineHeight: 1 }}>
          {Math.trunc(account.balance)}
        </MUI.Typography>
        <MUI.Typography variant="h5" color={account.balance >= 0 ? "success.main" : "error.main"} sx={{ ml: 0.5, fontWeight: 'bold' }}>
          ,{(Math.trunc(Math.abs(account.balance) % 1 * 100)).toFixed(0).padStart(2, '0')} ₽
        </MUI.Typography>
      </MUI.Box>

      <MUI.Box display="flex" gap={1}>
        <MUI.Button variant="contained">
          Пополнить
        </MUI.Button>
      </MUI.Box>

    </MUI.Paper>
  );
};

export default AccountSummary;
